export const INITIALISE_TEST_START = 'INITIALISE_TEST_START'
export const INITIALISE_TEST_COMPLETED = 'INITIALISE_TEST_COMPLETED'
export const INITIALISE_TEST_ERROR = 'INITIALISE_TEST_ERROR'

export const GET_RESULT = 'GET_RESULT'
